import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-download-alt': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M537.6 226.6c58.4 11.8 102.4 63.5 102.4 125.4 0 70.7-57.3 128-128 128h-368c-79.5 0-144-64.5-144-144 0-62.8 40.2-116.2 96.2-135.9-0.1-2.7-0.2-5.4-0.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2 15.2-10.2 33.6-16.2 53.3-16.2 53 0 96 43 96 96 0 12.2-2.3 23.9-6.4 34.6zM404.7 315.3c10.1-10.1 2.9-27.3-11.3-27.3h-65.4v-112c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v112h-65.4c-14.2 0-21.4 17.2-11.3 27.3l105.4 105.4c6.2 6.2 16.4 6.2 22.6 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-download-alt.js
// module id = 1208
// module chunks = 0